export const boxListRetailers = {
	display: 'flex',
	alignItems: 'center',
	flexWrap: 'wrap',
	pl: 2,
	pb: 2,
	div: {
		minWidth: 145,
		display: 'flex',
		alignItems: 'center',
		mr: 2,
		p: {
			flexGrow: 'initial'
		}
	}
}